export const downloadCSVData = (
  csvdataString = '',
  fileName = 'csvfilename',
  fileFormat = 'csv'
) => {
  
  const BOM = '\uFEFF'
  const csvdataWithBOM = BOM + csvdataString
  const name = `${fileName}.${fileFormat}`
  const blob = new Blob([csvdataWithBOM], { type: 'text/csv;charset=utf-8;' })
  try {
    /* for IE */
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, name)
    } else {
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', name)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  } catch (error) {
    console.error(error)
  }
}
